module.exports = require("./declare.js");


//////////////////
// WEBPACK FOOTER
// ./~/declare.js/index.js
// module id = 1336
// module chunks = 0